import {
    Table, TableBody, TableCell, TableHead, TableRow,
    Paper, TablePagination, TextField, Box
} from "@mui/material";
import React, { useState } from "react";

export default function MPSteelElevatedTempTable({ rows, onSearchChange, searchValue: searchValueProp }) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchValue, setSearchValue] = useState(searchValueProp ?? "");

    const temperatureColumns = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500];

    const handleChangePage = (_, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        if (onSearchChange) onSearchChange(value);
    };

    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Paper
            sx={{
                borderRadius: "4px",
                p: 2,
                overflow: "auto",
            }}
        >
            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Procurar..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    sx={{
                        width: 250,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            transition: "all 0.2s ease-in-out",
                        },
                    }}
                />
            </Box>

            <Table sx={{borderCollapse: "collapse" }}>
                <TableHead>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell colSpan={2}>Steel grade</TableCell>
                        <TableCell rowSpan={2}>Nominal thickness t</TableCell>
                        <TableCell colSpan={temperatureColumns.length}>
                            R₀.₂ MPa at temperature
                        </TableCell>
                    </TableRow>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell>Steel name</TableCell>
                        <TableCell>Steel number</TableCell>
                        {temperatureColumns.map(t => (
                            <TableCell key={t}>{t} °C</TableCell>
                        ))}
                    </TableRow>

                </TableHead>

                <TableBody>
                    {paginatedRows.map((row, rowIndex) => (
                        <React.Fragment key={row.id || rowIndex}>
                            {row.properties.map((property, propIndex) => (
                                <TableRow key={propIndex} sx={{ "& td": { border: "1px solid var(--border-color)", textAlign: "center" } }}>

                                    {propIndex === 0 && (
                                        <TableCell rowSpan={row.properties.length}>
                                            {row.steelName}
                                        </TableCell>
                                    )}

                                    {propIndex === 0 && (
                                        <TableCell rowSpan={row.properties.length}>
                                            {row.steelNumber}
                                        </TableCell>
                                    )}

                                    <TableCell>{property.nominalThickness}</TableCell>

                                    {temperatureColumns.map(temp => {
                                        const key = `proofStrength${temp}C`;
                                        const val = property[key];
                                        return (
                                            <TableCell key={temp}>
                                                {val ?? "–"}
                                            </TableCell>
                                        );
                                    })}

                                </TableRow>
                            ))}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>

            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Paper>
    );
}
